
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteQ as ObiOwnShipRemoteQElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-q.js';
 
 
 

 
 export const ObiOwnShipRemoteQ = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-q',
   elementClass: ObiOwnShipRemoteQElement,
   events: {
     
   }
  });
 
 